/* SantoLoco Fin Finder (c) 2026 SantoLoco Hawaii. All rights reserved. The Fin Finder, its sizing method and code are the property of SantoLoco and may not be copied or reused. */
if (/(^|\.)santoloco\.com$|^santoloco-hawaii\.myshopify\.com$|\.shopifypreview\.com$/.test(location.hostname))
(function () {
var _0xa0 = (document.currentScript && document.getElementById(document.currentScript.getAttribute('data-root'))) || document.querySelector('.ff');
if (!_0xa0)
return;
var _0xb7 = [];
try {
_0xb7 = JSON.parse(_0xa0.querySelector('.ff__data').textContent);
}
catch (_0xc4) { }
var _0xd1 = _0xa0.querySelector('.ff__form');
var _0xe8 = _0xa0.querySelector('.ff__results');
var _0xf5 = _0xa0.querySelector('.ff__error');
var _0xg2 = { ability: null, wave: null, board: null, tail: 'standard', style: 'both', sides: 'no', system: 'any' };
var _0xh9 = { longboard: 1, midlength: 1, longtwin: 1 };
function _0xi6() {
var _0xj3 = _0xg2.board;
_0xa0.querySelector('.ff__lenhint').textContent = _0xh9[_0xj3] ? '(needed for fin height)' : '(optional)';
_0xa0.querySelector('.ff__style').hidden = _0xj3 !== 'longboard';
_0xa0.querySelector('.ff__sides').hidden = !(_0xj3 === 'longboard' || _0xj3 === 'midlength');
}
_0xa0.querySelectorAll('.ff__chips').forEach(function (_0xk0) {
_0xk0.addEventListener('click', function (_0xl7) {
var _0xm4 = _0xl7.target.closest('button');
if (!_0xm4)
return;
_0xk0.querySelectorAll('button').forEach(function (_0xn1) { _0xn1.classList.remove('is-on'); });
_0xm4.classList.add('is-on');
_0xg2[_0xk0.dataset.name] = _0xm4.dataset.value;
if (_0xk0.dataset.name === 'board')
_0xi6();
});
});
_0xa0.querySelectorAll('input[name=units]').forEach(function (_0xo8) {
_0xo8.addEventListener('change', function () {
var _0xp5 = _0xd1.units.value === 'metric';
_0xa0.querySelector('.ff__us').hidden = _0xp5;
_0xa0.querySelector('.ff__metric').hidden = !_0xp5;
});
});
function _0xq2(_0xr9) { var _0xs6 = parseFloat(_0xd1[_0xr9].value); return isNaN(_0xs6) ? null : _0xs6; }
function _0xt3(_0xu0) { return (Math.round(_0xu0 * 100) / 100).toString().replace(/\.0+$/, '') + '"'; }
function _0xv7(_0xw4) { var _0xx1 = Math.floor(_0xw4), _0xy8 = Math.round((_0xw4 - _0xx1) * 12); if (_0xy8 === 12) {
_0xx1++;
_0xy8 = 0;
} return _0xx1 + "'" + _0xy8 + '"'; }
var _0xz5 = ['Grom', 'Small', 'Medium', 'Large', 'X-Large'];
var _0xaa2 = [['Grom', 0, 120], ['Small', 120, 155], ['Medium', 140, 175], ['Large', 165, 200], ['X-Large', 190, 999]];
var _0xab9 = [['Grom', 75, 115], ['Small', 105, 155], ['Medium', 145, 195], ['Large', 180, 999]];
var _0xac6 = [['Small', 0, 165], ['Medium', 154, 198], ['Large', 187, 999]];
function _0xad3(_0xae0, _0xaf7, _0xag4) {
var _0xah1 = _0xae0.filter(function (_0xai8) { return _0xaf7 >= _0xai8[1] && _0xaf7 < _0xai8[2]; });
if (!_0xah1.length)
return _0xaf7 < _0xae0[0][2] ? _0xae0[0][0] : _0xae0[_0xae0.length - 1][0];
if (_0xah1.length === 1)
return _0xah1[0][0];
return _0xag4 > 0 ? _0xah1[_0xah1.length - 1][0] : _0xah1[0][0];
}
function _0xaj5(_0xak2, _0xal9) { var _0xam6 = _0xz5.indexOf(_0xak2) + _0xal9; return _0xz5[Math.max(0, Math.min(_0xz5.length - 1, _0xam6))]; }
function _0xan3(_0xao0) {
var _0xap7 = _0xao0.replace(/\b\d-[A-Za-z]\b/g, '');
var _0xaq4 = _0xap7.match(/(?:^|[^\w.])(\d{1,2}(?:\.\d{1,3})?)(?![\w])/g) || [];
for (var _0xar1 = 0; _0xar1 < _0xaq4.length; _0xar1++) {
var _0xas8 = parseFloat(_0xaq4[_0xar1].replace(/[^\d.]/g, ''));
if (_0xas8 >= 1 && _0xas8 <= 11)
return _0xas8;
}
return null;
}
function _0xat5(_0xau2) {
var _0xav9 = [];
(_0xau2.vs || []).forEach(function (_0xaw6) {
var _0xax3 = /^\s*(\d{1,2}(?:\.\d{1,3})?)\s*("|”|in)?\s*$/.exec(_0xaw6.t || '');
if (_0xax3) {
var _0xay0 = parseFloat(_0xax3[1]);
if (_0xay0 >= 1 && _0xay0 <= 11)
_0xav9.push({ h: _0xay0, a: _0xaw6.a, id: _0xaw6.id });
}
});
if (!_0xav9.length) {
var _0xaz7 = _0xan3(_0xau2.t);
if (_0xaz7 != null)
_0xav9.push({ h: _0xaz7, a: !_0xau2.cs, id: null });
}
return _0xav9;
}
function _0xba4(_0xbb1, _0xbc8) {
var _0xbd5 = null;
_0xat5(_0xbb1).forEach(function (_0xbe2) {
var _0xbf9 = Math.abs(_0xbe2.h - _0xbc8) - (_0xbe2.a ? 0.01 : 0);
if (!_0xbd5 || _0xbf9 < _0xbd5.d)
_0xbd5 = { h: _0xbe2.h, a: _0xbe2.a, id: _0xbe2.id, d: _0xbf9 };
});
if (_0xbd5)
_0xbd5.d = Math.abs(_0xbd5.h - _0xbc8);
return _0xbd5;
}
var _0xbg6 = /pivot|noserider/i;
var _0xbh3 = /\brak(e|ed)\b|4-a|greenough/i;
var _0xbi0 = /keel|fish/i;
var _0xbj7 = { 'FCS II': 1, 'FCS Original': 1, 'Futures': 1 };
function _0xbk4(_0xbl1) { return _0xbl1.setup === 'Single' && /2\s*\+\s*1/.test(_0xbl1.t); }
function _0xbm8(_0xbn5) {
if (_0xbj7[_0xbn5.system])
return _0xbn5.system;
var _0xbo2 = _0xbn5.t + ' ' + (_0xbn5.v || '');
if (/\bfcs ?(ii|2)\b/i.test(_0xbn5.t))
return 'FCS II';
if (/\bfcs\b/i.test(_0xbo2))
return 'FCS';
if (/\bfutures?\b/i.test(_0xbo2))
return 'Futures';
return null;
}
var _0xbp9 = {
small: [/\bT2\b/i, 'T2 Twin', 'speed generating, for small or soft waves'],
everyday: [/\bEN\b/i, 'EN Twin', 'balanced, all-around'],
big: [/britt|\bBMT\b/i, 'Britt Merrick Twin', 'speed control, for big or powerful waves'],
hollow: [/britt|\bBMT\b/i, 'Britt Merrick Twin', 'speed control, for big or powerful waves']
};
var _0xbq6 = /christenson twin|\bEN\b|rasta/i;
_0xd1.addEventListener('submit', function (_0xbr3) {
_0xbr3.preventDefault();
var _0xbs0 = _0xd1.units.value === 'metric';
var _0xbt7 = _0xbs0 ? _0xq2('kg') : (_0xq2('lb') ? _0xq2('lb') * 0.4536 : null);
var _0xbu4 = _0xbt7 ? _0xbt7 / 0.4536 : null;
var _0xbv1 = _0xq2('bft') ? _0xq2('bft') + (_0xq2('bin') || 0) / 12 : null;
var _0xbw8 = [];
if (!_0xbt7)
_0xbw8.push('weight');
['ability', 'wave', 'board'].forEach(function (_0xbx5) { if (!_0xg2[_0xbx5])
_0xbw8.push(_0xbx5 === 'wave' ? 'waves' : _0xbx5); });
if (_0xh9[_0xg2.board] && !_0xbv1)
_0xbw8.push('board length');
if (_0xbw8.length) {
_0xf5.textContent = 'Add your ' + _0xbw8.join(', ') + ' to see your fins.';
_0xf5.hidden = false;
return;
}
_0xf5.hidden = true;
var _0xby2 = _0xg2.ability, _0xbz9 = _0xg2.wave, _0xca6 = _0xg2.board, _0xcb3 = _0xg2.tail, _0xcc0 = _0xg2.system;
var _0xcd7 = [], _0xce4 = [], _0xcf1 = [], _0xcg8 = '', _0xch5 = [], _0xci2 = null;
var _0xcj9 = null;
var _0xck6 = null;
var _0xcl3 = false;
var _0xcm0 = null;
var _0xcn7 = 0;
if (_0xbz9 === 'big' || _0xbz9 === 'hollow')
_0xcn7++;
if (_0xbz9 === 'small')
_0xcn7--;
if (_0xcb3 === 'wide')
_0xcn7++;
if (_0xcb3 === 'narrow')
_0xcn7--;
if (_0xby2 === 'beginner')
_0xcn7++;
if (_0xby2 === 'advanced' && _0xbz9 === 'small')
_0xcn7--;
var _0xco4 = _0xbz9 === 'small' || _0xbz9 === 'hollow' ? 'Reactor (upright, beach breaks and the pocket)'
: _0xbz9 === 'big' ? 'Carver or Accelerator (more sweep, long walls and reefs)' : 'Performer (all conditions)';
var _0xcp1 = _0xbz9 === 'small' ? 'Ride Number 7–10 (speed generating, e.g. Blackstix)'
: _0xbz9 === 'everyday' ? 'Ride Number 4–7 (balanced, e.g. Honeycomb)' : 'Ride Number 1–4 (speed control, e.g. Techflex or Control)';
if (_0xca6 === 'shortboard' || _0xca6 === 'stepup') {
var _0xcq8 = _0xca6 === 'stepup' ? 1 : 0;
var _0xcr5 = _0xaj5(_0xad3(_0xaa2, _0xbu4, _0xcn7), _0xcq8), _0xcs2 = _0xaj5(_0xad3(_0xab9, _0xbu4, _0xcn7), _0xcq8);
if (_0xcs2 === 'X-Large')
_0xcs2 = 'Large';
_0xcj9 = function (_0xct9) { return _0xct9.system === 'Futures' ? _0xcs2 : _0xcr5; };
_0xch5 = (_0xca6 === 'stepup' || _0xbz9 === 'hollow' || (_0xbz9 === 'big' && _0xby2 !== 'beginner')) ? ['Thruster', 'Quad'] : ['Thruster'];
if (_0xbz9 === 'small' && _0xby2 !== 'beginner')
_0xch5 = ['Thruster', 'Quad'];
_0xcg8 = (_0xcr5 === _0xcs2 ? _0xcr5 : 'FCS ' + _0xcr5 + ' / Futures ' + _0xcs2) + ' ' + _0xch5.join(' or ').toLowerCase();
_0xce4 = [['Setup', _0xch5.join(' or ')], ['FCS size', _0xcr5], ['Futures size', _0xcs2], ['Template', _0xbz9 === 'big' ? 'Raked' : _0xbz9 === 'everyday' ? 'Neutral' : 'Upright / pivot']];
_0xcd7.push('At ' + Math.round(_0xbu4) + ' lb you fit FCS ' + _0xcr5 + ' and Futures ' + _0xcs2 + '. The brands use different charts, so each is sized on its own.');
if (_0xca6 === 'stepup')
_0xcd7.push('Step-ups go one size up, with more rake and a stiffer build for control at speed.');
if (_0xch5.indexOf('Quad') > -1)
_0xcd7.push(_0xbz9 === 'small' ? 'A quad generates speed in small surf.' : 'A quad holds speed in barrels and down the line; a thruster gives more control in critical sections.');
if (_0xcb3 === 'wide')
_0xcd7.push('A wide tail needs more fin area to hold, so we sized up within your range.');
_0xce4.push(['FCS family', _0xco4.split(' (')[0]], ['Futures flex', _0xcp1.split(' (')[0]]);
}
else if (_0xca6 === 'fish' || _0xca6 === 'twinpin' || _0xca6 === 'longtwin') {
var _0xcu6 = _0xad3(_0xac6, _0xbu4, _0xcn7);
var _0xcv3 = _0xca6 === 'longtwin' && _0xbv1 >= 7;
if (_0xcv3)
_0xcu6 = _0xaj5(_0xcu6, 1);
if (_0xcu6 === 'X-Large')
_0xcu6 = 'Large';
_0xcj9 = function () { return _0xcu6; };
var _0xcw0 = { Small: 'S-M', Medium: 'M-L', Large: 'L-XL' }[_0xcu6];
if (_0xca6 === 'fish') {
_0xck6 = _0xcb3 === 'wide' || _0xbz9 === 'small' || _0xbz9 === 'everyday';
_0xch5 = ['Twin / Keel', 'Twinzer', '2+1 / Twin+1'];
_0xcg8 = _0xcw0 + ' ' + (_0xck6 ? 'keels' : 'twins');
_0xcd7.push('Fish want big-area keels: long base, drive down the line. Wide swallow tails take the biggest keels.');
if (!_0xck6) {
_0xcd7.push('In steeper, hollow waves an upright twin turns tighter in the pocket than a keel.');
_0xcm0 = [_0xbq6, 'Christenson Twin, EN Twin or Rasta Twin+1', 'Futures’ picks for performance twins like the Album Twinsman'];
_0xcd7.push('For performance twins like the Album Twinsman, Futures recommends the Christenson Twin, EN Twin or Rasta Twin+1.');
}
}
else if (_0xca6 === 'twinpin') {
_0xck6 = _0xbz9 === 'small';
_0xcl3 = true;
_0xcm0 = _0xbp9[_0xbz9];
_0xch5 = ['Twin / Keel', '2+1 / Twin+1'];
_0xcg8 = _0xcw0 + (_0xck6 ? ' keels or hybrid twins' : ' hybrid twins');
_0xcd7.push('Twin pins are built to run as a true twin. Britt Merrick designed a special twin template for CI’s Twin Pin, between a keel and an upright, for a balance of drive, hold and turning.');
_0xcd7.push('Futures’ pick for the CI Twin Pin in your waves: ' + _0xcm0[1] + ' (' + _0xcm0[2] + '). Their full range runs T2 Twin for small surf, EN Twin for everyday and Britt Merrick Twin for power.');
if (_0xbz9 === 'small')
_0xcd7.push('In small surf, keels also add drive and glide on a twin pin.');
if (_0xbz9 === 'big' || _0xbz9 === 'hollow')
_0xcd7.push('A small trailer is an option if you want more bite on your backhand in bigger surf.');
_0xcf1.push('Twin pins have low rails, so CI says most people ride them at least 1/8" thicker than their shortboard.');
}
else {
_0xck6 = _0xbz9 === 'big' || _0xcb3 === 'wide';
_0xch5 = ['Twin / Keel', '2+1 / Twin+1', 'Twinzer'];
_0xcg8 = _0xcw0 + (_0xck6 ? ' big keels' : ' large twins') + ', ~5.1"–5.7" deep';
_0xcd7.push('Long twins (' + _0xv7(_0xbv1) + ') need big twins: about 5.1–5.7" deep with a 5–5.9" base. Thomas runs the MV2 on FCS Power Twins; the CI Mid Twin uses L-XL Britt Merrick twins; Lovelace makes the FM Twin for mids.');
_0xcd7.push('Thomas builds the MV2 from 6\'2" to 7\'6" and the Long Fish, a stretched-out keel fish, from 6\'6" to 7\'8". Both lean on big fins for drive and hold on rail.');
if (_0xcb3 === 'wide')
_0xcd7.push('Swallow-tail long fish, like the Thomas Long Fish, are keel boards. Keels give them hold on rail and drive through long, drawn-out turns.');
if (_0xbz9 === 'small' && !_0xck6)
_0xcd7.push('In small surf, big upright twins keep a long board turning and gliding.');
if (_0xbz9 === 'big')
_0xcd7.push('On long walls, keels give drive (CI’s Devon Howard runs keels on his Mid Twin from armpit-high up).');
if (_0xbz9 === 'hollow' || _0xby2 === 'beginner')
_0xcd7.push('A trailer is optional, but adds hold and stability in steep sections or while you learn the board.');
_0xcf1.push('Run long twins as a true twin first; add a small trailer only if it feels loose. Twins in thruster side boxes often disappoint.');
}
_0xcd7.push('At ' + Math.round(_0xbu4) + ' lb you fit FCS Specialty ' + _0xcw0 + ' sizing' + (_0xcv3 ? ', sized up one for a board over 7\'' : '') + '.');
_0xce4 = [['Setup', _0xca6 === 'twinpin' ? 'Twin, trailer optional' : _0xca6 === 'longtwin' ? 'Twin (+ optional trailer)' : 'Twin or keel'], ['Size', _0xcw0], ['Style', _0xca6 === 'twinpin' && !_0xck6 ? 'Hybrid twin' : _0xck6 ? 'Keel' : 'Upright / hybrid twin']];
if (_0xca6 === 'longtwin')
_0xce4.push(['Depth', '5.1"–5.7"'], ['Base', '5.0"–5.9"']);
if (_0xca6 === 'twinpin')
_0xce4.push(['Futures pick', _0xcm0[1]]);
_0xce4.push(['Stiffness', _0xbz9 === 'small' ? 'Some flex' : 'Stiff base']);
if (_0xbz9 === 'big' || _0xbz9 === 'hollow')
_0xcf1.push('Thin, flexy twins lose control in powerful surf. Pick fiberglass or a stiff base.');
}
else {
var _0xcx7 = _0xbv1;
var _0xcy4 = _0xcx7;
if (_0xca6 === 'midlength')
_0xcy4 = _0xcx7 - 0.25;
if (_0xcb3 === 'wide')
_0xcy4 += 0.5;
else if (_0xcb3 === 'narrow')
_0xcy4 -= 0.5;
if (_0xbt7 < 60)
_0xcy4 -= 0.5;
else if (_0xbt7 < 70)
_0xcy4 -= 0.25;
else if (_0xbt7 > 95)
_0xcy4 += 0.5;
else if (_0xbt7 > 85)
_0xcy4 += 0.25;
if (_0xca6 === 'longboard' && _0xg2.style === 'nose')
_0xcy4 += 0.25;
if (_0xca6 === 'longboard' && _0xg2.style === 'turns')
_0xcy4 -= 0.25;
if (_0xbz9 === 'big' || _0xbz9 === 'hollow')
_0xcy4 += 0.25;
if (_0xby2 === 'beginner')
_0xcy4 += 0.25;
var _0xcz1 = _0xg2.sides === 'yes';
if (_0xcz1) {
_0xcy4 = _0xcx7 <= 7.5 ? 6.5 : _0xcx7 <= 8.5 ? 6.5 + (_0xcx7 - 7.5) * 0.5 : _0xcx7 <= 9 ? 7 : _0xcx7 <= 9.5 ? 7 + (_0xcx7 - 9) * 3 : 8.5;
if (_0xbt7 > 85)
_0xcy4 += 0.25;
else if (_0xbt7 < 60)
_0xcy4 -= 0.25;
if (_0xca6 === 'longboard' && _0xg2.style === 'nose')
_0xcy4 += 0.25;
}
if (_0xcy4 < 6)
_0xcy4 = 6;
_0xcy4 = Math.round(_0xcy4 * 4) / 4;
var _0xda8 = _0xbu4 > 160 ? 4.0 : 3.6;
_0xci2 = { fin: _0xcy4, len: _0xcx7, sides: _0xcz1, side: _0xda8 };
_0xch5 = _0xcz1 ? ['Single', 'Side Bites'] : ['Single'];
_0xcg8 = 'About ' + (/^(8|11)(\.|$)/.test(String(_0xcy4)) ? 'an ' : 'a ') + _0xt3(_0xcy4) + (_0xcz1 ? ' center fin + side bites' : ' single fin');
var _0xdb5 = _0xca6 === 'longboard'
? (_0xg2.style === 'nose' ? 'Pivot / noserider' : _0xg2.style === 'turns' ? 'Raked or flex' : 'Balanced (e.g. Greenough 4-A)')
: (_0xbz9 === 'small' ? 'Upright / pivot' : 'Raked');
if (_0xca6 === 'longboard' && _0xg2.style === 'both' && _0xbz9 === 'small')
_0xdb5 = 'Pivot';
_0xce4 = [['Fin height', _0xt3(_0xcy4)], ['Template', _0xdb5], ['Board', _0xv7(_0xcx7)]];
if (_0xcz1)
_0xce4.push(['Side bites', '~' + _0xda8.toFixed(1) + '"']);
if (!_0xcz1)
_0xcd7.push('The classic rule is about 1" of fin per foot of board: your ' + _0xv7(_0xcx7) + '. Shops size noseriders bigger and performance fins a touch shorter.');
if (!_0xcz1 && _0xcb3 === 'wide')
_0xcd7.push('Wider tails need deeper fins to hold, so we added about half an inch.');
if (!_0xcz1 && _0xcb3 === 'narrow')
_0xcd7.push('Narrower tails hold with less fin, so we came down about half an inch.');
if (_0xbt7 < 70)
_0xcd7.push('Lighter surfers usually go a touch smaller or more flexible.');
if (_0xbt7 > 85)
_0xcd7.push('Heavier surfers can push a slightly bigger, stiffer fin.');
if (_0xcz1)
_0xcd7.push('A 2+1 runs a smaller center fin than a single fin board: about 6.5–7" on midlengths (Channel Islands CI Mid, Pyzel Mid Crisis), about 7" on 8\'6"–9\' boards and 8.5" on 9\'6"–10\' logs (Hawaiian South Shore). CI sizes side bites at 3.6" up to about 160 lb and 4.0" above.');
if (_0xca6 === 'longboard' && _0xg2.style === 'nose')
_0xcd7.push('Pivot and noserider fins anchor the tail so you can hang on the nose.');
if (_0xca6 === 'longboard' && _0xg2.style === 'turns')
_0xcd7.push('Raked and flex fins draw out turns and project off the bottom.');
if (_0xbz9 === 'small' && _0xca6 === 'midlength')
_0xcd7.push('In small, soft waves an upright fin turns tighter.');
if (_0xbz9 === 'big' || _0xbz9 === 'hollow')
_0xcd7.push('Bigger, faster waves want more rake and hold.');
if (_0xby2 === 'beginner')
_0xcd7.push('A little extra size adds stability while you learn to trim.');
}
var _0xdc2 = _0xcc0 === 'FCS Original' ? 'original FCS' : _0xcc0;
var _0xdd9 = { 'Futures': 'FCS or FCS II', 'FCS II': 'Futures or original FCS', 'FCS Original': 'Futures or FCS II' }[_0xcc0];
if (_0xbj7[_0xcc0])
_0xcd7.push(_0xci2 ? 'Your center fin goes in a standard single fin box, so we show longboard-box center fins and ' + _0xdc2 + ' side bites. Nothing for ' + _0xdd9 + ' boxes: they won’t fit yours.' : 'Showing only ' + _0xdc2 + ' fins. Nothing for ' + _0xdd9 + ' boxes: they won’t fit yours.');
else if (_0xcc0 === 'Longboard Box')
_0xcd7.push('Showing only fins that fit a standard longboard box.');
_0xcf1.push('Futures, FCS II and original FCS are three different box systems. Futures fins have one long base and a screw; FCS II fins click in with no screws; original FCS fins have two tabs held by grub screws. Check your board before you buy.');
if (_0xcc0 === 'FCS II')
_0xcf1.push('Original FCS fins only go in FCS II boxes with FCS’s compatibility kit. FCS II fins don’t fit original FCS plugs at all.');
if (_0xcc0 === 'FCS Original')
_0xcf1.push('FCS II fins don’t fit original FCS plugs. Look for fins marked FCS, dual tab or FCS compatible.');
if (_0xca6 === 'shortboard' || _0xca6 === 'stepup')
_0xcf1.push('Brand shorthand for your waves: FCS ' + _0xco4 + '; Futures ' + _0xcp1 + '.');
if (_0xby2 === 'beginner')
_0xcf1.push('Fiberglass or Performance Glass fins feel predictable while you learn. Very flexy fins are harder to control.');
var _0xde6 = _0xb7.filter(function (_0xdf3) {
if (!_0xdf3.setup || _0xch5.indexOf(_0xdf3.setup) < 0)
return false;
if (_0xbj7[_0xcc0]) {
var _0xdg0 = _0xbm8(_0xdf3);
if (_0xdg0 === 'FCS' ? _0xcc0 === 'Futures' : (_0xdg0 && _0xdg0 !== _0xcc0))
return false;
var _0xdh7 = _0xci2 && _0xdf3.setup === 'Single' && _0xdf3.system === 'Longboard Box';
if (!_0xdh7 && _0xdf3.system !== _0xcc0)
return false;
}
else if (_0xcc0 === 'Longboard Box') {
if (_0xdf3.system !== 'Longboard Box')
return false;
}
if (!_0xci2 && _0xdf3.system === 'Longboard Box')
return false;
if (_0xbk4(_0xdf3) && !(_0xci2 && _0xci2.sides))
return false;
if (_0xcj9 && _0xdf3.size && _0xz5.indexOf(_0xdf3.size) > -1) {
var _0xdi4 = _0xcj9(_0xdf3);
if (Math.abs(_0xz5.indexOf(_0xdf3.size) - _0xz5.indexOf(_0xdi4)) >= 2)
return false;
if (_0xca6 === 'longtwin' && _0xz5.indexOf(_0xdf3.size) < _0xz5.indexOf(_0xdi4))
return false;
}
if (_0xci2 && _0xdf3.setup === 'Single') {
var _0xdj1 = _0xba4(_0xdf3, _0xci2.fin);
if (!_0xdj1 || _0xdj1.d > (_0xci2.sides ? 0.75 : 1))
return false;
_0xdf3._z = _0xdj1;
}
if (_0xci2 && _0xdf3.setup === 'Side Bites') {
var _0xdk8 = _0xba4(_0xdf3, _0xci2.side);
if (!_0xdk8 || _0xdk8.d > 0.4)
return false;
_0xdf3._z = _0xdk8;
}
return true;
}).map(function (_0xdl5) {
var _0xdm2 = 0, _0xdn9 = [], _0xdo6 = [];
var _0xdp3 = _0xch5.indexOf(_0xdl5.setup);
_0xdm2 += (_0xch5.length - _0xdp3) * 2;
if (_0xdp3 === 0)
_0xdo6.push('It’s a ' + _0xdl5.setup.toLowerCase() + ' setup, the one we recommend for your board and waves.');
else
_0xdo6.push('A ' + _0xdl5.setup.toLowerCase() + ' option that also suits your board.');
if (_0xdl5.setup === 'Thruster' || _0xdl5.setup === 'Quad') {
var _0xdq0 = _0xco4.split(' (')[0].split(' or ');
var _0xdr7 = _0xdq0.filter(function (_0xds4) { return new RegExp('\\b' + _0xds4 + '\\b', 'i').test(_0xdl5.t); })[0];
if (_0xdl5.system !== 'Futures' && _0xdr7) {
_0xdm2 += 1;
_0xdo6.push('The ' + _0xdr7 + ' template is the FCS family for your waves: ' + _0xco4.split(' (')[1].replace(')', '') + '.');
}
var _0xdt1 = _0xbz9 === 'small' ? /blackstix/i : _0xbz9 === 'everyday' ? /honeycomb|\bHC\b/i : /techflex|control|fiberglass/i;
if (_0xdl5.system === 'Futures' && _0xdt1.test(_0xdl5.t + ' ' + (_0xdl5.build || ''))) {
_0xdm2 += 1;
_0xdo6.push('Its flex matches Futures’ ' + _0xcp1.split(' (')[0] + ' for your waves (' + _0xcp1.split(' (')[1].replace(')', '') + ').');
}
}
if (_0xcl3 && _0xdl5.setup === 'Twin / Keel') {
_0xdm2 += 2;
_0xdo6.push('Twin pins are designed to ride as a true twin, without a trailer.');
}
if (_0xcj9 && _0xdl5.size) {
var _0xdu8 = _0xcj9(_0xdl5), _0xdv5 = Math.abs(_0xz5.indexOf(_0xdl5.size) - _0xz5.indexOf(_0xdu8));
var _0xdw2 = _0xdl5.setup === 'Thruster' || _0xdl5.setup === 'Quad' ? (_0xdl5.system === 'Futures' ? 'Futures' : 'FCS') + ' weight chart' : 'twin and keel sizing';
if (_0xdv5 === 0) {
_0xdm2 += 6;
_0xdn9.push('Your size');
_0xdo6.push('Size ' + _0xdl5.size + ' is exactly your size on the ' + _0xdw2 + ' at ' + Math.round(_0xbu4) + ' lb.');
}
else if (_0xca6 === 'longtwin' && _0xz5.indexOf(_0xdl5.size) > _0xz5.indexOf(_0xdu8)) {
_0xdm2 += 5;
_0xdn9.push('Big fin');
_0xdo6.push('One size up (' + _0xdl5.size + '), which long twins need for hold on rail.');
}
else {
_0xdm2 += 2;
_0xdo6.push(_0xdl5.size + ' is one size from your ' + _0xdu8 + ', still within range for your weight.');
}
}
if (_0xcm0 && _0xcm0[0].test(_0xdl5.t)) {
_0xdm2 += 4;
_0xdn9.unshift(_0xca6 === 'twinpin' ? 'CI Twin Pin pick' : 'Futures pick');
_0xdo6.push(_0xca6 === 'twinpin' ? 'Futures’ pick for the CI Twin Pin in your waves: ' + _0xcm0[2] + '.' : 'One of Futures’ picks for performance twins like the Album Twinsman.');
}
if (_0xck6 !== null && _0xdl5.setup === 'Twin / Keel') {
var _0xdx9 = _0xbi0.test(_0xdl5.t);
if (_0xdx9 === _0xck6) {
_0xdm2 += 3;
_0xdn9.push(_0xdx9 ? 'Keel' : 'Upright twin');
_0xdo6.push(_0xdx9 ? 'A keel: long base for drive and glide, ideal for your tail and waves.' : 'An upright twin: turns tighter in the pocket of steeper waves.');
}
}
if (_0xci2 && _0xdl5.setup === 'Side Bites' && _0xdl5._z) {
var _0xdy6 = _0xdl5._z.d;
if (_0xdy6 <= 0.15) {
_0xdm2 += 7;
_0xdn9.push('Right size');
_0xdo6.push('At ' + _0xt3(_0xdl5._z.h) + ' it’s right at your ~' + _0xt3(_0xci2.side) + ' side bite size for ' + Math.round(_0xbu4) + ' lb.');
}
else {
_0xdm2 += 4;
_0xdo6.push('At ' + _0xt3(_0xdl5._z.h) + ' it’s close to your ~' + _0xt3(_0xci2.side) + ' side bite size.');
}
}
if (_0xci2 && _0xdl5.setup === 'Single') {
var _0xdz3 = _0xdl5._z ? _0xdl5._z.h : null;
if (_0xdz3 != null) {
var _0xea0 = Math.abs(_0xdz3 - _0xci2.fin);
if (_0xea0 <= 0.25) {
_0xdm2 += 7;
_0xdn9.push('Right height');
_0xdo6.push('At ' + _0xt3(_0xdz3) + ' it’s right at your recommended ' + _0xt3(_0xci2.fin) + ' fin height.');
}
else if (_0xea0 <= 0.5) {
_0xdm2 += 5;
_0xdo6.push('At ' + _0xt3(_0xdz3) + ' it’s within half an inch of your ' + _0xt3(_0xci2.fin) + ' target.');
}
else if (_0xea0 <= 1) {
_0xdm2 += 2;
_0xdo6.push('At ' + _0xt3(_0xdz3) + ' it’s within an inch of your ' + _0xt3(_0xci2.fin) + ' target.');
}
}
var _0xeb7 = (_0xca6 === 'longboard' && _0xg2.style === 'nose') || (_0xbz9 === 'small' && !(_0xca6 === 'longboard' && _0xg2.style === 'turns'));
var _0xec4 = (_0xca6 === 'longboard' && _0xg2.style === 'turns') || _0xbz9 === 'big' || _0xbz9 === 'hollow';
if (_0xeb7 && _0xbg6.test(_0xdl5.t)) {
_0xdm2 += 3;
_0xdn9.push('Pivot style');
_0xdo6.push('Pivot template: anchors the tail for noseriding and quick turns in small surf.');
}
if (_0xec4 && _0xbh3.test(_0xdl5.t)) {
_0xdm2 += 3;
_0xdn9.push('Raked');
_0xdo6.push('Raked template: draws out turns and holds in bigger, faster waves.');
}
if (_0xca6 === 'longboard' && _0xg2.style === 'both' && /4-a|greenough/i.test(_0xdl5.t)) {
_0xdm2 += 2;
_0xdn9.push('All-rounder');
_0xdo6.push('Greenough 4-A style: the classic all-round longboard fin for trim and turns.');
}
}
if (_0xci2 && _0xci2.sides && _0xdl5.setup === 'Side Bites') {
_0xdm2 += 1;
_0xdo6.push('Side bites complete your 2+1 setup.');
}
if (_0xci2 && _0xci2.sides && _0xbk4(_0xdl5)) {
_0xdm2 += 8;
_0xdn9.unshift('Complete 2+1 set');
_0xdo6.unshift('A complete 2+1: center fin and matching side bites in one set, so everything fits together.');
if (/CI Mid/i.test(_0xdl5.t))
_0xdo6.splice(1, 0, 'It’s the setup Channel Islands designed with Devon Howard for the CI Mid.');
var _0xed1 = /4\.0/.test(_0xdl5.t) ? 4.0 : /3\.6/.test(_0xdl5.t) ? 3.6 : null;
if (_0xed1)
_0xdo6.push('Its ' + _0xt3(_0xed1) + ' side bites ' + (Math.abs(_0xed1 - _0xci2.side) < 0.2 ? 'are your size.' : 'are a touch ' + (_0xed1 > _0xci2.side ? 'bigger' : 'smaller') + ' than your ~' + _0xt3(_0xci2.side) + '.'));
}
if (_0xca6 === 'midlength' && _0xdl5.board === 'Midlength') {
_0xdm2 += 1;
_0xdo6.push('Designed for midlengths.');
}
if (_0xby2 === 'advanced' && /Honeycomb|Performance Core/.test(_0xdl5.build || '')) {
_0xdm2 += 1;
_0xdo6.push(_0xdl5.build + ' build: light and responsive for hard turns.');
}
if (_0xby2 === 'beginner' && /Fiberglass|Performance Glass/.test(_0xdl5.build || '')) {
_0xdm2 += 1;
_0xdo6.push(_0xdl5.build + ' build: predictable while you learn.');
}
if (_0xca6 === 'stepup' && /Fiberglass|Performance Glass/.test(_0xdl5.build || '')) {
_0xdm2 += 1;
_0xdo6.push(_0xdl5.build + ' build: stiff and stable at speed.');
}
if (_0xcc0 !== 'any' && _0xdl5.system)
_0xdo6.push('Fits your ' + _0xdl5.system + (_0xdl5.system === 'Longboard Box' ? '.' : ' boxes.'));
if (/Island Fin Design/.test(_0xdl5.v))
_0xdm2 += 0.5;
return { p: _0xdl5, s: _0xdm2, tags: _0xdn9, r: _0xdo6 };
}).sort(function (_0xee8, _0xef5) { return _0xef5.s - _0xee8.s; });
var _0xeg2 = _0xci2 && _0xci2.sides;
function _0xeh9(_0xei6) { return _0xei6.filter(function (_0xej3) { return !_0xej3.p.cs; })[0] || _0xei6[0]; }
function _0xek0(_0xel7, _0xem4) { return _0xel7 && _0xem4 && _0xel7.s >= _0xem4.s * 0.85; }
function _0xen1(_0xeo8) { return _0xeo8.t.toLowerCase().split(/\s\d|\d/)[0].replace(/\s+(fin|fins)$/, '').trim(); }
var _0xep5, _0xeq2;
if (_0xeg2) {
var _0xer9 = _0xde6.filter(function (_0xes6) { return _0xbk4(_0xes6.p); });
var _0xet3 = _0xde6.filter(function (_0xeu0) { return _0xeu0.p.setup === 'Single' && !_0xbk4(_0xeu0.p); });
var _0xev7 = _0xde6.filter(function (_0xew4) { return _0xew4.p.setup === 'Side Bites'; });
var _0xex1 = _0xeh9(_0xet3), _0xey8 = _0xeh9(_0xev7), _0xez5 = _0xeh9(_0xer9);
_0xep5 = [_0xex1, _0xey8, _0xez5].filter(Boolean);
var _0xfa2 = _0xet3.filter(function (_0xfb9) { return _0xfb9 !== _0xex1 && (!_0xex1 || _0xen1(_0xfb9.p) !== _0xen1(_0xex1.p)); })[0];
if (_0xfa2 && (_0xep5.length < 2 || (_0xep5.length < 3 && _0xek0(_0xfa2, _0xex1))))
_0xep5.push(_0xfa2);
_0xeq2 = _0xde6.filter(function (_0xfc6) { return _0xep5.indexOf(_0xfc6) < 0; });
_0xeq2.sort(function (_0xfd3, _0xfe0) { return (_0xfd3.p.cs - _0xfe0.p.cs) || (_0xfe0.s - _0xfd3.s); });
}
else {
var _0xff7 = _0xeh9(_0xde6);
_0xeq2 = _0xde6.filter(function (_0xfg4) { return _0xfg4 !== _0xff7; });
_0xep5 = _0xff7 ? [_0xff7] : [];
var _0xfh1 = _0xff7 ? [_0xen1(_0xff7.p)] : [];
_0xeq2.forEach(function (_0xfi8) {
if (_0xep5.length >= 3)
return;
if (_0xfh1.indexOf(_0xen1(_0xfi8.p)) > -1)
return;
if (_0xep5.length === 2 && !_0xek0(_0xfi8, _0xff7))
return;
_0xep5.push(_0xfi8);
_0xfh1.push(_0xen1(_0xfi8.p));
});
if (_0xff7 && _0xep5.length < 2 && _0xeq2[0])
_0xep5.push(_0xeq2[0]);
_0xeq2 = _0xeq2.filter(function (_0xfj5) { return _0xep5.indexOf(_0xfj5) < 0; }).sort(function (_0xfk2, _0xfl9) { return (_0xfk2.p.cs - _0xfl9.p.cs) || (_0xfl9.s - _0xfk2.s); });
}
var _0xfm6 = _0xa0.querySelector('.ff__grid'), _0xfn3 = _0xa0.querySelector('.ff__more'), _0xfo0 = _0xa0.querySelector('.ff__picks');
function _0xfp7(_0xfq4) { return _0xfq4.i ? '<img loading="lazy" src="' + _0xfq4.i + '" alt="">' : '<span class="ff__noimg"></span>'; }
function _0xfr1(_0xfs8) { return _0xfs8._z ? _0xt3(_0xfs8._z.h) + (_0xat5(_0xfs8).length > 1 ? (_0xfs8._z.a ? ' in stock' : ' coming soon') : '') + ' · ' : ''; }
function _0xft5(_0xfu2) { return _0xfu2.u + (_0xfu2._z && _0xfu2._z.id && _0xat5(_0xfu2).length > 1 ? '?variant=' + _0xfu2._z.id : ''); }
function _0xfv9(_0xfw6) { return '<p>' + _0xfw6.v + (_0xfw6.system ? ' · ' + _0xfw6.system : '') + '</p><p class="ff__price">' + _0xfr1(_0xfw6) + (_0xfw6.cs ? 'Coming soon · ' : '') + _0xfw6.p + '</p>'; }
function _0xfx3(_0xfy0) {
var _0xfz7 = _0xfy0.p, _0xga4 = _0xfz7.cs ? 'Coming soon' : _0xeg2 ? (_0xbk4(_0xfz7) ? 'Complete 2+1 set' : _0xfz7.setup === 'Single' ? 'Center fin' : 'Side bites') : (_0xfy0.tags[0] || _0xfz7.setup);
return '<a class="ff__card" href="' + _0xft5(_0xfz7) + '">' + _0xfp7(_0xfz7) +
'<div><span class="ff__badge' + (_0xfz7.cs ? ' ff__badge--soon' : '') + '">' + _0xga4 + '</span><h3>' + _0xfz7.t.replace(/</g, '&lt;') + '</h3>' + _0xfv9(_0xfz7) + '</div></a>';
}
function _0xgb1(_0xgc8, _0xgd5) {
var _0xge2 = _0xgc8.p;
var _0xgf9 = _0xge2.cs ? ' · Coming soon' : '';
var _0xgg6 = _0xeg2
? (_0xbk4(_0xge2) ? 'Complete 2+1 set' : _0xge2.setup === 'Side Bites' ? 'Your 2+1 · Side bites' : (_0xgc8 !== _0xep5[0] ? 'Center fin · Option 2' : 'Your 2+1 · Center fin')) + _0xgf9
: (_0xgd5 === 0 ? (_0xge2.cs ? '#1 Best match · Coming soon' : '#1 Best match in stock') : '#' + (_0xgd5 + 1) + (_0xgd5 === 1 ? ' Also a great fit' : ' Another top pick') + _0xgf9);
var _0xgh3 = _0xgc8.r.slice(0, 4);
if (_0xge2.cs)
_0xgh3.push('Not in the shop yet: it’s on order and coming soon.');
return '<a class="ff__pick" href="' + _0xft5(_0xge2) + '">' + _0xfp7(_0xge2) +
'<div><span class="ff__badge' + (_0xge2.cs ? ' ff__badge--soon' : '') + '">' + _0xgg6 + '</span><h3>' + _0xge2.t.replace(/</g, '&lt;') + '</h3>' + _0xfv9(_0xge2) +
'<p class="ff__whyh">Why it works</p><ul>' + _0xgh3.map(function (_0xgi0) { return '<li>' + _0xgi0 + '</li>'; }).join('') + '</ul></div></a>';
}
function _0xgj7(_0xgk4) {
var _0xgl1 = _0xgk4.some(function (_0xgm8) { return !_0xgm8.p.cs; }), _0xgn5 = _0xgk4.some(function (_0xgo2) { return _0xgo2.p.cs; });
_0xa0.querySelector('.ff__h').textContent = (_0xeg2 ? 'More center fins and side bites that fit' : 'More fins that fit') + (_0xgl1 && _0xgn5 ? ': in stock & coming soon' : _0xgn5 ? ': coming soon' : '');
_0xa0.querySelector('.ff__h').hidden = !_0xgk4.length;
_0xfm6.innerHTML = _0xgk4.map(_0xfx3).join('');
}
var _0xgp9 = '';
if (_0xeg2) {
var _0xgq6 = _0xep5.some(function (_0xgr3) { return _0xgr3.p.setup === 'Single' && !_0xbk4(_0xgr3.p); }), _0xgs0 = _0xep5.some(function (_0xgt7) { return _0xgt7.p.setup === 'Side Bites'; });
var _0xgu4 = _0xep5.some(function (_0xgv1) { return _0xbk4(_0xgv1.p); });
_0xgp9 = '<p class="ff__setnote">' + (_0xgq6 && _0xgs0 ? 'A 2+1 needs both: one center fin for your single box and a pair of side bites for your side boxes. Here’s the best pair for you' + (_0xgu4 ? ', or grab the complete set.' : '.')
: _0xgu4 ? 'The easiest way to a 2+1: a complete set with the center fin and side bites together.'
: _0xgq6 ? 'No side bites in your size' + (_0xbj7[_0xcc0] ? ' for ' + _0xdc2 + ' boxes' : '') + ' right now, so here are your best center fins. Message us and we’ll get you a pair of side bites.'
: 'No center fin in your size right now. Message us and we’ll get you one.') + '</p>';
}
_0xfo0.innerHTML = _0xgp9 + (_0xep5.length ? _0xep5.map(_0xgb1).join('') : '');
if (!_0xep5.length)
_0xfo0.innerHTML = '<p>Nothing in stock matches this exactly right now. Message us or stop by the shop in Haleiwa and we’ll set you up.</p>';
var _0xgw8 = _0xeq2.slice(0, 6);
_0xgj7(_0xgw8);
_0xa0.querySelector('.ff__fit').innerHTML = '<h2>Your fit: ' + _0xcg8 + '</h2>' +
'<div class="ff__specs">' + _0xce4.map(function (_0xgx5) { return '<div class="ff__spec"><span>' + _0xgx5[0] + '</span><strong>' + _0xgx5[1] + '</strong></div>'; }).join('') + '</div>' +
'<ul>' + _0xcd7.map(function (_0xgy2) { return '<li>' + _0xgy2 + '</li>'; }).join('') + '</ul>';
_0xfn3.innerHTML = _0xeq2.length > _0xgw8.length
? '<button type="button" class="ff__all">See all ' + _0xde6.length + ' fins that fit &darr;</button>'
: (_0xde6.length > 0 && _0xde6.length < 3 ? 'Only ' + _0xde6.length + ' ' + (_0xde6.length === 1 ? 'fin fits' : 'fins fit') + ' this setup right now. Stop by the shop in Haleiwa or <a href="/pages/contact-us">message us</a> and we’ll sort you out.' : '');
var _0xgz9 = _0xfn3.querySelector('.ff__all');
if (_0xgz9)
_0xgz9.addEventListener('click', function () { _0xgj7(_0xeq2); _0xfn3.innerHTML = ''; });
_0xa0.querySelector('.ff__tips').innerHTML = '<h3>Good to know</h3><ul>' + _0xcf1.map(function (_0xha6) { return '<li>' + _0xha6 + '</li>'; }).join('') + '</ul>';
_0xd1.hidden = true;
_0xe8.hidden = false;
_0xe8.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
_0xa0.querySelector('.ff__restart').addEventListener('click', function () {
_0xe8.hidden = true;
_0xd1.hidden = false;
_0xd1.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
})();
